import DelectoryResource from '../DelectoryResource';

const OneMinute = 1000 * 60;

class Customers extends DelectoryResource {
  constructor(opts) {
    super(opts);

    this.auth = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/market/customers/auth'
    });

    this.me = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/me'
    });

    this.resetPassword = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/market/customers/reset_password'
    });

    this.updatePassword = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/update_password'
    });

    this.addIdentifier = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/add_identifier'
    });

    this.updateContactInfo = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/update_contact_info'
    });

    this.updatePreferences = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/update_preferences'
    });

    this.updateNotificationSettings = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/update_notification_settings'
    });

    this.addPaymentMethod = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/add_payment_method'
    });

    this.removePaymentMethod = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/remove_payment_method'
    });

    this.addShippingAddress = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/add_shipping_address'
    });

    this.updateShippingAddress = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/update_shipping_address'
    });

    this.removeShippingAddress = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/customers/remove_shipping_address'
    });
  }
}

export default Customers;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/resources/Customers.js